import * as React from "react";

export type TooltipParagraphProps = React.HTMLAttributes<HTMLParagraphElement> & {
  toggleTip(tip: JSX.Element, anchor: HTMLElement): void,
  tip: JSX.Element
};

export const TooltipParagrah : React.SFC<TooltipParagraphProps> = props =>  {
    let {tip, className, children, ...pProps} = props;
    let tipParagraph = (
      <p className={`${className || ''} tool-tip-paragraph`} 
        {...pProps}>
        {children}
        {
          props.toggleTip 
          ? <label className="tool-tip-label"
              onClick={x => {
              x.preventDefault();
              x.stopPropagation();
              props.toggleTip(tip, x.currentTarget);
              }}>?</label>
          : null
        }
    </p>);
    return tipParagraph;
}




// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Views/v4/TooltipParagraph.tsx